import { createReducer } from 'typesafe-actions';
import {
  confirmSignUpAsync,
  exchangeTokenAsync,
  forgotPasswordAsync,
  getAuthorizedUserAsync,
  getPermissionAsync,
  resendSignUpAsync,
  setAuthorizedUser,
  signInAsync,
  signUpAsync,
  submitForgotPasswordAsync,
} from './actions';
import { AuthUser, Permission } from './types';

export type IAuthState = Readonly<{
  authUser: AuthUser | null;
  permissions: Permission[];
  error?: AuthError;
  verifyError?: AuthError;
  isAuthenticated: boolean | null;

  loading: boolean;
  isSubmittingCode: boolean;
  isResendingCode: boolean;
  isSigningIn: boolean;
  isResetPasswordSuccess: boolean;
}>;

/* ------------- Initial State ------------- */
const initialState: IAuthState = {
  authUser: null,
  permissions: [],
  error: null,
  verifyError: null,
  isAuthenticated: null,

  loading: false,
  isSigningIn: false,
  isSubmittingCode: false,
  isResendingCode: false,
  isResetPasswordSuccess: false,
};

export default createReducer(initialState)
  /* ------------- signInAsync ------------- */
  .handleAction(signInAsync.request, state => ({
    ...state,
    isSigningIn: true,
  }))
  .handleAction(signInAsync.success, state => ({
    ...state,
    isSigningIn: false,
    error: null,
  }))
  .handleAction(signInAsync.failure, (state, action) => ({
    ...state,
    isSigningIn: false,
    error: action.payload,
  }))

  /* ------------- signUpAsync ------------- */
  .handleAction(signUpAsync.request, state => ({
    ...state,
    loading: true,
    verifyError: null,
  }))
  .handleAction(signUpAsync.success, state => ({
    ...state,
    loading: false,
    error: null,
  }))
  .handleAction(signUpAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))

  /* ------------- resendSignUpAsync ------------- */
  .handleAction(resendSignUpAsync.request, state => ({
    ...state,
    isResendingCode: true,
    verifyError: null,
  }))
  .handleAction(resendSignUpAsync.success, state => ({
    ...state,
    isResendingCode: false,
    verifyError: null,
  }))
  .handleAction(resendSignUpAsync.failure, (state, action) => ({
    ...state,
    isResendingCode: false,
    verifyError: action.payload,
  }))

  /* ------------- confirmSignUpAsync ------------- */
  .handleAction(confirmSignUpAsync.request, state => ({
    ...state,
    isSubmittingCode: true,
    verifyError: null,
  }))
  .handleAction(confirmSignUpAsync.success, state => ({
    ...state,
    isSubmittingCode: false,
    verifyError: null,
  }))
  .handleAction(confirmSignUpAsync.failure, (state, action) => ({
    ...state,
    isSubmittingCode: false,
    verifyError: action.payload,
  }))

  /* ------------- forgotPasswordAsync ------------- */
  .handleAction(forgotPasswordAsync.request, state => ({
    ...state,
    loading: true,
  }))
  .handleAction(forgotPasswordAsync.success, state => ({
    ...state,
    loading: false,
    error: null,
    isResetPasswordSuccess: false,
  }))
  .handleAction(forgotPasswordAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))

  /* ------------- submitForgotPasswordAsync ------------- */
  .handleAction(submitForgotPasswordAsync.request, state => ({
    ...state,
    loading: true,
    isResetPasswordSuccess: false,
  }))
  .handleAction(submitForgotPasswordAsync.success, state => ({
    ...state,
    loading: false,
    error: null,
    isResetPasswordSuccess: true,
  }))
  .handleAction(submitForgotPasswordAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))

  /* ------------- exchangeTokenAsync ------------- */
  .handleAction(exchangeTokenAsync.request, state => ({
    ...state,
    loading: true,
  }))
  .handleAction(exchangeTokenAsync.success, state => ({
    ...state,
    loading: false,
  }))
  .handleAction(exchangeTokenAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
  /* ------------- getAuthorizedUser ------------- */
  .handleAction(getAuthorizedUserAsync.request, state => ({
    ...state,
    loading: true,
  }))
  .handleAction(getAuthorizedUserAsync.success, state => ({
    ...state,
    loading: false,
  }))
  .handleAction(getAuthorizedUserAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
  /*----------setAuthorizedUser-----------*/
  .handleAction(setAuthorizedUser, (state, action) => ({
    ...state,
    ...action.payload,
  }))

  /* ------------- getPermissionAsync ------------- */
  .handleAction(getPermissionAsync.request, state => ({
    ...state,
    loading: true,
  }))
  .handleAction(getPermissionAsync.success, (state, action) => ({
    ...state,
    loading: false,
    permissions: action.payload,
  }))
  .handleAction(getPermissionAsync.failure, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }));
